 "use strict";
 /**
  * trsTooltip Module
  *
  * Description
  */
 angular.module('trsTooltipModule', []).directive('trsTooltip', ['$window', '$parse', '$timeout', function($window, $parse, $timeout) {

     return {
         restrict: 'EA',
         link: function(scope, iElement, iAttrs) {
             var tooltip;
             iElement.addClass("has-tool-tip");
             bindScroll();
             bindKeyPress();
             var option = {
                 container: iAttrs.container ? iAttrs.container : false
             };
             $timeout(function() {
                 tooltip = iElement.tooltip(option);
             });
             window.addEventListener("blur", windowBlur);
             window.addEventListener("focus", windowFocus);

             function windowBlur() {
                 tooltip = iElement.tooltip('destroy');
             }

             function windowFocus() {
                 $("body").bind("mousemove", mousemoveEvent);
                 /**
                  * [mousemoveEvent description]鼠标移动事件
                  * @return {[type]} [description]
                  */
                 function mousemoveEvent() {
                     tooltip = iElement.tooltip(option);
                     $("body").unbind("mousemove", mousemoveEvent);
                 }

             }
             scope.$on("$destroy", function() {
                 window.removeEventListener("blur", windowBlur);
                 window.removeEventListener("focus", windowFocus);
                 $(".tooltip.fade").remove();
                 tooltip = iElement.tooltip('destroy');
             });
             /**
              * [bindScroll description] 禁止滚动事件
              * @return {[type]} [description]
              */
             function bindScroll() {
                 window.addEventListener("mousewheel", myScroll);

                 function myScroll() {
                     $(".tooltip.fade.in").remove();
                 }
                 scope.$on("$destroy", function() {
                     window.removeEventListener("mousewheel", myScroll);
                 });
             }
             /**
              * [bindKeyPress description] 绑定按键
              * @return {[type]} [description]
              */
             function bindKeyPress() {
                 window.addEventListener("keydown", myScroll);

                 function myScroll(e) {
                     if (e.key !== "ArrowDown" && e.key !== "ArrowUp" && e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
                     $(".tooltip.fade.in").remove();
                 }
                 scope.$on("$destroy", function() {
                     window.removeEventListener("mousewheel", myScroll);
                 });
             }
         }
     };
 }]);